// Product gallery glue: enable magnifier only on active slide (desktop/hover devices).
(function() {
  if(!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if(!window.MzImageMagnifier || typeof window.MzImageMagnifier.init !== 'function') return;

  function resetSlide(slide) {
    if(!slide) return;
    var mag = slide.getElementsByClassName('img-mag')[0];
    if(mag) {
      mag.classList.remove('js-img-mag');
    }

    var img = slide.getElementsByClassName('img-mag__asset')[0];
    if(img) {
      img.classList.remove('js-img-mag__asset');
      img.removeAttribute('style'); // reset transform applied by magnifier
    }
  }

  function activateSlide(slide) {
    if(!slide) return;
    var mag = slide.getElementsByClassName('img-mag')[0];
    var img = slide.getElementsByClassName('img-mag__asset')[0];
    if(!mag || !img) return;

    mag.classList.add('js-img-mag');
    img.classList.add('js-img-mag__asset');

    window.MzImageMagnifier.init(slide);
  }

  function initThumbslide(thumbslide) {
    var slideshow = thumbslide.getElementsByClassName('slideshow')[0];
    if(!slideshow) return;

    var slides = slideshow.getElementsByClassName('js-slideshow__item');
    if(!slides || slides.length < 1) return;

    // initial state: ensure only the selected slide is active
    var selected = slideshow.getElementsByClassName('slideshow__item--selected')[0];
    for(var i = 0; i < slides.length; i++) {
      if(slides[i] !== selected) resetSlide(slides[i]);
    }
    activateSlide(selected);

    slideshow.addEventListener('newItemSelected', function(event) {
      var index = event && typeof event.detail === 'number' ? event.detail : -1;
      if(index < 0 || index >= slides.length) return;

      for(var i = 0; i < slides.length; i++) {
        if(i !== index) resetSlide(slides[i]);
      }
      activateSlide(slides[index]);
    });
  }

  var thumbslides = document.getElementsByClassName('js-thumbslide');
  if(thumbslides.length < 1) return;
  for(var i = 0; i < thumbslides.length; i++) {
    initThumbslide(thumbslides[i]);
  }
}());

